import _, { map } from 'underscore';
import moment from 'moment';

( function( $ ) {

	$( function() {

		moment.locale( 'nl' );

		/*
		oud textarea groter maken op focus
		$( '.js-comment-input' ).on( 'focus', function() {
			var $this = $( this );

			$this.addClass( '-large' );

		} );

		$( '.js-comment-input' ).on( 'blur', function() {
			var $this = $( this );

			if( $.trim( $this.val() ) == '' ) {
				$this.removeClass( '-large' );
			}

		} );
		*/

		// 

		function set_show_more( el ) {

			// class zit op parent
			if( el.offsetHeight < el.scrollHeight ) {
				$( el ).closest( '.js-comments' ).removeClass( '-hide-show-all-btn' )
			} else {
				$( el ).closest( '.js-comments' ).addClass( '-hide-show-all-btn' )
			}

		}

		// laadtijd zoveel terug e.d.. Geef .js-comments door
		function set_comments_meta( $wrapper ) {

			var $time = $wrapper.find( '.js-comments-time' ),
			 	$count = $wrapper.find( '.js-comments-count' );

			var amount = $wrapper.find( '.comment-box' ).length;

			if( amount == '1' ) {
				$count.text( '1 Reactie' );
			} else {
				$count.text( amount + ' Reacties' );
			}

			var load_time = moment();

			$time.text( 'Laatste update: ' + moment().format( 'H:mm:ss' ) );
			
			$wrapper.find( '.js-comments-ago' ).replaceWith( '<span class="js-comments-ago"></span>' );

			var $ago = $wrapper.find( '.js-comments-ago' );

			var set = null;
			
			clearInterval( set );

			set = setInterval( function() {

				$ago.text( '(' + moment( load_time ).fromNow() + ')' );
			
			}, 1000 );

		}

		// 

		$( '.js-expand-call' ).on( 'click', function() {

			var $this = $( this ),
				$box = $this.closest( '.box' ),
				$list = $box.find( '.ajax-comments__list' );

			$this.toggleClass( '-active' );
			$box.find( '.compact' ).toggleClass( '-show' );

			$list.trigger( 'click' );

			set_show_more( $list[0] );

			$list[0].scrollTop = $list[0].scrollHeight;

		} );

		// 

		$( window ).on( 'load', function() {

			$( '.js-comments-list' ).each( function() {

				set_show_more( this );

				// Zet scroll naar beneden
				this.scrollTop = this.scrollHeight;

				set_comments_meta( $( this ).closest( '.js-comments' ) );

			} );

			$( '.js-loader' ).addClass( '-hide' ).removeClass( '-initial-load' );

		} );

		$( '.js-show-all-comments' ).on( 'click', function() {
			// class zit op parent. haal overflow weg
			$( this ).closest( '.js-comments' ).addClass( '-show-all-comments' );
		} );

		function getCaret(el) {
			if (el.selectionStart) {
				return el.selectionStart;
			} else if (document.selection) {
				el.focus();
	
				var r = document.selection.createRange();
				if (r == null) {
					return 0;
				}
	
				var re = el.createTextRange(),
					rc = re.duplicate();
				re.moveToBookmark(r.getBookmark());
				rc.setEndPoint('EndToStart', re);
	
				return rc.text.length;
			}  
			return 0;
		}

		// Laat shift/ctrl enters toe. Losse enter is submit
		// met keyup doet e.preventDefault() het niet 
		// https://stackoverflow.com/questions/19804378/jquery-to-submit-textarea-with-enter-key
		$( '.js-comment-input' ).on( 'keypress', function( e ){

			var $this = $( this );

			if ((e.keyCode == 13 || e.keyCode == 10) && ( e.ctrlKey || e.shiftKey ) ) {
				var content = $(this).val();
				var caret = getCaret(this);
				$(this).val(content.substring(0,caret)+
							""+content.substring(caret,content.length));
				e.stopPropagation();
			} else if (e.keyCode == 13 || e.keyCode == 10){
				e.preventDefault();
				$this.closest( 'form' ).submit();
			}
	
		} );

		// https://css-tricks.com/auto-growing-inputs-textareas/
		function calcHeight(value) {
			let numberOfLineBreaks = (value.match(/\n/g) || []).length;
			// min-height + lines x line-height + padding + border
			let newHeight = 58 + numberOfLineBreaks * 28 + 0 + 0;
			return newHeight;
		}

		// pas hoogte aan textarea voor enters
		$( '.js-comment-input' ).on( 'keyup paste', function( e ){
			$( this ).css( 'height', calcHeight( $( this ).val() ) );
		} );

		// sluiten boven textarea
		$( '.js-comment-respond-to' ).on( 'click', '.js-close-respond', function() {

			var $this = $( this );
			
			var $wrapper = $this.closest( '.js-comments' ),
				$to_label = $wrapper.find( '.js-comment-respond-to' ),
				$hidden = $wrapper.find( '.js-comment-parent' );

			$wrapper.find( '.js-comment' ).removeClass( '-responding' );
			$to_label.empty();
			$hidden.val( '' );

		} );

		// reactie op
		$( '.js-comments-list' ).on( 'click', '.js-respond', function() {

			var $this = $( this );

			var $comment = $this.closest( '.js-comment' ),
				$list = $comment.closest( '.js-comments-list' ),
				$wrapper = $list.closest( '.js-comments' ),
				$to_label = $wrapper.find( '.js-comment-respond-to' ),
				$hidden = $wrapper.find( '.js-comment-parent' );

			var respond_id = $this.data( 'cid' ),
				parent_id = $comment.data( 'cid' );

			// al aan het reageren op
			if( $comment.hasClass( '-responding' ) ) {

				$wrapper.find( '.js-comment' ).removeClass( '-responding' );
				
				$to_label.empty();
				$hidden.val( '' );

				return;

			}

			$wrapper.find( '.js-comment' ).removeClass( '-responding' );
			$to_label.empty();

			$to_label.html( '<div><span class="label">Reageer op: ' + $comment.find( '.name' ).text() + '</span><span class="action js-close-respond">Sluiten</span></div>' );

			$comment.addClass( '-responding' );

			$hidden.val( respond_id );

		} );

		// verwijder
		$( '.js-comments-list' ).on( 'click', '.js-remove-comment', function() {

			var $this = $( this );

			if( confirm( 'Weet je het zeker? Dit kan niet ongedaan worden' ) ) {

				var cid = $( this ).data( 'cid' ),
					pid = $( this ).data( 'pid' );

				var $wrapper = $this.closest( '.js-comments' ),
					$list = $wrapper.find( '.js-comments-list' ),
					$loader = $wrapper.find( '.js-loader' );

				$loader.removeClass( '-hide' );

				$.ajax( {
					type: 'POST',
					dataType: 'JSON',
					url: ajax.url,
					data: {
						action: 'delete_comment',
						cid: cid,
						pid: pid
					},
				} ).done( function( response ) {
	
					console.log( response );
	
					if( response.success == true ) {

						var data = response.data;

						$wrapper.find( '.js-comment-parent' ).val( '' );
						$wrapper.find( '.js-comment-respond-to' ).empty();

						$list.html( data.html );

						set_comments_meta( $wrapper );
						set_show_more( $list[0] );

						$list[0].scrollTop = $list[0].scrollHeight;
	
					} else {

						var msg = 'Er gaat iets niet helemaal goed.';
	
						if( 'data' in response ) {
							msg += ' Zie de volgende foutmelding: ' + response.data[0].message;
						} else {
							msg += ' Ververs de pagina en probeer het opnieuw';
						}

						alert( msg );
	
					}
	
				} )
				.fail( function( response ) {
		
					alert( 'Er iets verkeerd met het verwijderen van de reactie. Ververs de pagina en probeer het opnieuw' )
	
				} )
				.always( function( response ) {
	
					$loader.addClass( '-hide' );
	
				} );

			}

		} );

		// verstuur reactie
		$( '.js-comments-form' ).on( 'submit', function( e ) {

			e.preventDefault();

			var $this = $( this ),
				$input = $this.find( '.js-comment-input' ),
				val = $.trim( $input.val() );

			if( val == '' ) {
				return;
			}

			if( val.length < 2 ) {
				alert( 'Graag meer invullen' );
				return;
			}

			var $wrapper = $this.closest( '.js-comments' ),
				$list = $wrapper.find( '.js-comments-list' ),
				$loader = $wrapper.find( '.js-loader' ),
				pid = $wrapper.data( 'pid' ),
				parent = $wrapper.find( '.js-comment-parent' ).val();

			$loader.removeClass( '-hide' );

			$.ajax( {
				type: 'POST',
				dataType: 'JSON',
				url: ajax.url,
				data: {
					action: 'comment',
					input: val,
					pid: pid,
					parent: parent
				},
			} ).done( function( response ) {

				console.log( response );

				if( response.success == true ) {

					var data = response.data;

					$input.val( '' ).attr( 'style', '' );
					$wrapper.find( '.js-comment-parent' ).val( '' );
					$wrapper.find( '.js-comment-respond-to' ).empty();

					$list.html( data.html );

					set_comments_meta( $wrapper );
					set_show_more( $list[0] );

					$list[0].scrollTop = $list[0].scrollHeight;

				} else {

					var msg = 'Er gaat iets niet helemaal goed.';
	
					if( 'data' in response ) {
						msg += ' Zie de volgende foutmelding: ' + response.data[0].message;
					} else {
						msg += ' Ververs de pagina en probeer het opnieuw';
					}

					alert( msg );

				}

			} )
			.fail( function( response ) {

				alert( 'Er iets verkeerd met het versturen van de reactie. Ververs de pagina en probeer het opnieuw' )

			} )
			.always( function( response ) {

				$loader.addClass( '-hide' );

			} );

		} );

		$( '.js-comments-reload' ).on( 'click', function( e ) {

			var $this = $( this );

			var $wrapper = $this.closest( '.js-comments' ),
				$list = $wrapper.find( '.js-comments-list' ),
				$loader = $wrapper.find( '.js-loader' ),
				pid = $wrapper.data( 'pid' );

			$loader.removeClass( '-hide' );

			$.ajax( {
				type: 'POST',
				dataType: 'JSON',
				url: ajax.url,
				data: {
					action: 'reload_comments',
					pid: pid
				},
			} ).done( function( response ) {

				if( response.success == true ) {

					var data = response.data;

					$list.html( data.html );

					set_comments_meta( $wrapper );
					set_show_more( $list[0] );

					$list[0].scrollTop = $list[0].scrollHeight;

				} else {

					var msg = 'Er gaat iets niet helemaal goed.';

					if( 'data' in response ) {
						msg += ' Zie de volgende foutmelding: ' + response.data[0].message;
					} else {
						msg += ' Ververs de pagina en probeer het opnieuw';
					}

					alert( msg );

				}

			} )
			.fail( function( response ) {
	
				alert( 'Er iets verkeerd met het laden van de reacties. Ververs de pagina en probeer het opnieuw' )

			} )
			.always( function( response ) {

				$loader.addClass( '-hide' );

			} );

		} );

	} );

} ) ( jQuery );